import { Injectable } from '@angular/core';
import { environment } from '@ecs-environment';
import { SEARCH_TERM_SEPARATOR } from '@ecs-services/search/search.helper';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@os-components';
import * as SearchActions from './search.actions';

@Injectable({ providedIn: 'root' })
export class SearchEffectsService {
    public constructor(
        private languageService: LanguageService,
        private translateService: TranslateService
    ) {}

    public getNoResultsError(searchTerm: string[], needToCheckForOrderItems: boolean) {
        const locale = this.languageService.language.toLowerCase();
        const subject = encodeURIComponent(
            this.translateService.instant('SEARCH.ACTION.OPEN_CONTACT_FORM.SUBJECT')
        );
        const encodedSearchTerm = encodeURIComponent(searchTerm.join(SEARCH_TERM_SEPARATOR));

        return SearchActions.receiveSearchResult({
            payload: {
                searchResult: null,
                searchError: {
                    content: 'SEARCH.ERROR.UNSUCCESSFUL',
                    followUpLink: {
                        text: 'SEARCH.ACTION.OPEN_CONTACT_FORM.LINK',
                        href: `${environment.baseURLs.api.domain}/${locale}/technical_pages/forwarding/forwarding_os_contact_form.html?subject=${subject}&mailbody=${encodedSearchTerm}`,
                    },
                    ...(needToCheckForOrderItems ? { orderNumberItemsChecked: false } : {}),
                },
            },
            userRequested: true,
        });
    }

    public getNoElectronicsResultsError(searchTerm: string[]) {
        const locale = this.languageService.language.toLowerCase();
        const subject = encodeURIComponent(
            this.translateService.instant('SEARCH.ACTION.OPEN_CONTACT_FORM.SUBJECT')
        );
        const encodedSearchTerm = encodeURIComponent(searchTerm.join(SEARCH_TERM_SEPARATOR));

        return SearchActions.receiveElectronicsError({
            payload: {
                electronicsTabSearchError: {
                    content: 'SEARCH.ERROR.UNSUCCESSFUL',
                    followUpLink: {
                        text: 'SEARCH.ACTION.OPEN_CONTACT_FORM.LINK',
                        href: `${environment.baseURLs.api.domain}/${locale}/technical_pages/forwarding/forwarding_os_contact_form.html?subject=${subject}&mailbody=${encodedSearchTerm}`,
                    },
                },
            },
        });
    }

    public updateOrderNumberItemChecked(orderNumberItemsChecked: boolean) {
        return SearchActions.updateOrderNumberItemChecked({
            payload: {
                orderNumberItemsChecked,
            },
        });
    }
}
